<template>
  <div>
    <form @submit.prevent="onSearch">
      <input type="text" v-model="query" @input="fetchSuggestions" placeholder="Enter command..." />
      <button type="submit">Search</button>
    </form>
    <ul v-if="suggestions.length" class="suggestions">
      <li v-for="suggestion in suggestions" :key="suggestion.fileName" @click="selectSuggestion(suggestion.fileName)">
        {{ suggestion.fileName }}
      </li>
    </ul>
    <MarkdownViewer v-if="selectedContent" :htmlContent="selectedContent" />
  </div>
</template>

<script>
import { loadMarkdownFiles, search } from '@/utils/search';
import MarkdownViewer from './MarkdownViewer.vue';

export default {
  name: 'SearchBar',
  components: { MarkdownViewer },
  data() {
    return {
      query: '',
      suggestions: [],
      selectedContent: ''
    };
  },
  async created() {
    console.log('SearchBar.vue created');
    await loadMarkdownFiles();
  },
  methods: {
    fetchSuggestions() {
      console.log('Fetching suggestions for:', this.query); // Log the query
      if (this.query.length > 0) {
        this.suggestions = search(this.query);
      } else {
        this.suggestions = [];
      }
    },
    onSearch() {
      console.log('Search submitted for:', this.query); // Log the search query
      this.selectedContent = ''; // Clear the selected content
      this.suggestions = search(this.query); // Fetch suggestions
    },
    selectSuggestion(fileName) {
      console.log('Selected file in SearchBar.vue:', fileName); // Log the selected file name
      this.query = fileName;
      const result = search(fileName)[0];
      this.selectedContent = result ? result.htmlContent : 'File not found';
      this.suggestions = []; // Clear search results
      this.$emit('selectFile', fileName);
    }
  }
}
</script>

<style scoped>
.suggestions {
  list-style-type: none;
  padding: 0;
  margin: 0;
  background-color: #fff;
  color: #000;
  width: 100%;
}
.suggestions li {
  padding: 0.5rem;
  cursor: pointer;
}
.suggestions li:hover {
  background-color: #ddd;
}
form {
  display: flex;
  gap: 0.5rem;
}
input {
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
button {
  padding: 0.5rem 1rem;
  border: none;
  background-color: #3498db;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
}
</style>
